module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/yogasix-e5424073ddc709ca56f6526c06fc0653.png";